<template>
  <div>
    <TopNavbar title="发布动态" :rightText="postLoading?'发布中':'发布'" @clickRight="onClickPost" :isLoading="postLoading"></TopNavbar>
    <div class="create-container">
      <Field
          v-model="description"
          rows="1"
          :autosize="{minHeight: 100, maxHeight:150}"
          type="textarea"
          placeholder="这一刻的想法..."
          maxlength="2000"
      >
      </Field>
      <div class="uploader-container">
        <Uploader
            v-model="fileList"
            :after-read="onAfterRead"
            multiple
            :max-count="9"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import {Field, Uploader, Toast, Button, Dialog, Icon, Popup} from "vant"
  import TopNavbar from "../../common/TopNavbar";

  export default {
    name: "MomentCreate",
    components: {
      TopNavbar, Icon, Popup, Field, Uploader, Toast, Button
    },
    data() {
      return {
        postLoading: false,
        refItemId: 0,
        title: "",
        description: "",
        userInfo: {},

        autoSize: {
          minHeight: 30
        },

        fileList: [],
        fileImageUrisMap: {},
      }
    },
    async mounted() {
      let refId = this.$route.query.ref_item_id
      if (refId) {
        try {
          this.refItemId = parseInt(refId)
        } catch (e) {
        }
      }
      this.loadBackupData()
      await this.getUserInfo()
    },
    beforeDestroy() {
      this.saveBackUpData()
    },
    methods: {
      async getUserInfo() {
        await this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          if (data) {
            this.userInfo = data
          }
        })
      },

      saveBackUpData(isClear) {
        let file_list = []
        let data = {}
        if (isClear) {
        } else {
          for (let i = 0; i < this.fileList.length; i++) {
            file_list.push({
              "url": this.fileList[i].url,
              "uri": this.fileList[i].uri,
            })
          }
          data = {
            title: this.title,
            description: this.description,
            file_list: file_list,
          }
        }

        try {
          localStorage.setItem("moment_local", JSON.stringify(data))
        } catch (e) {
          console.log(e)
        }
      },

      loadBackupData() {
        try {
          let s = localStorage.getItem("moment_local")
          if (s) {
            let data = JSON.parse(s)
            if (data.title) {
              this.title = data.title
            }
            if (data.description) {
              this.description = data.description
            }
            if (data.file_list) {
              for (let i = 0; i < data.file_list.length; i++) {
                this.fileList.push({url: data.file_list[i].url, uri: data.file_list[i].uri})
              }
            }
          }
        } catch (e) {
          console.log(e)
        }
      },

      goBack() {
        this.$router.go(-1)
      },

      async onClickPost() {
        if (this.postLoading) {
          return
        }

        let imageUris = []
        for (let i = 0; i < this.fileList.length; i++) {
          imageUris.push(this.fileList[i].uri)
        }

        if (!this.description && (!imageUris || imageUris.length === 0)) {
          Toast("请输入内容")
          return
        }

        this.postLoading = true
        let params = {
          title: this.title,
          description: this.description,
          image_uris: imageUris,
          ref_item_id: this.refItemId,
        }

        await this.$store.dispatch("CreateMoment", params).then((data) => {
          if (data.code === 0) {
            Toast("发表成功")
            this.title = ""
            this.description = ""
            this.fileList = []
            setTimeout(() => {
              this.goBack()
            }, 500)
          } else if (data.code === 20010) {
            this.$router.push("/login")
          }
        }, () => {
          Toast("网络错误")
        })
        this.postLoading = false
      },

      onAfterRead(file) {
        if (Array.isArray(file)) {
          for (let i = 0; i < file.length; i ++) {
            this.onAfterReadSingleFile(file[i])
          }
        } else {
          this.onAfterReadSingleFile(file)
        }
      },

      onAfterReadSingleFile(file) {
        let params = new FormData()
        params.append('file', file.file)
        params.append("source", "moment")
        file.status = "uploading"

        this.$store.dispatch("UploadImage", params).then((data) => {
          if (data.code === 0) {
            file.status = "done"
            file.uri = data.data.uri
            file.url = data.data.image_normal.url
          } else {
            file.status = "failed"
            Toast(data.msg || "上传失败")
          }
        }, () => {
          file.status = "failed"
          Toast("网络错误")
        })
      },
    },
    computed: {
    }
  }
</script>

<style lang="scss" scoped>

  .create-container {
    padding: 50px 15px;

    .page-title {
      font-size: 18px;
      text-align: center;
      padding: 24px 0;
    }
  }

  .uploader-container {
    margin-top: 10px;
  }

</style>
